import {Component, OnDestroy, OnInit} from "@angular/core";
import {DOCUMENT_TYPES} from "../../enums/enums";
import {BusService, INewDocumentEvent} from "../../services/bus.service";
import {paramsHelper} from "../../helpers/params-helper";
import {UI_TEXTS} from "../../enums/e-texts";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {IDocument} from "../../interfaces/document.definition";
import {localeUtils} from "../../helpers/locale-utils";
import {ISearchItem} from "../../definitions";
import {Subject} from "rxjs/Subject";
import {CollectionService} from "../../services/collection.service";
import {createObjectLink, createObjectLinkQuery} from "../../helpers/create-object-link";

@Component({
  selector: 'app-quest-page',
  templateUrl: './quest-page.component.html',
  styles: []
})
export class QuestPageComponent implements OnInit, OnDestroy {
  UI_TEXTS = UI_TEXTS;
  pageParams = paramsHelper.page()
    .setTitle("Квесты");

  collectionParams = paramsHelper.collection()
    .setObjectType(DOCUMENT_TYPES.QUESTS)
    .setDefaultListLabels()
    .setItemLabelQuery('codeName')
    .setSearchParams(paramsHelper.search()
      .addParam('codeName', SEARCH_PROP_TYPES.STRING, "")
      .addNumberParam("gameEventsComponent")
      .addNumberParam("id"));

  document: IDocument;

  linkedArcs:Array<ISearchItem>;

  private unsubscribe: Subject<void> = new Subject<void>();


  constructor(private busService: BusService,
              private collectionService:CollectionService) {
  }


  ngOnInit() {
    this.busService.onDocumentUpdated
      .takeUntil(this.unsubscribe)
      .subscribe(
        e => this.onDocumentUpdated(e));
  }

  ngOnDestroy(){
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private onDocumentUpdated(e: INewDocumentEvent) {
    this.document = e.document;

    if (this.document) {
      this.loadLinkedArcs();
    }
  }

  private loadLinkedArcs()
  {
    this.linkedArcs = [];

    const searchParams = paramsHelper.search()
      .addParam("_type", SEARCH_PROP_TYPES.STRING, DOCUMENT_TYPES.QUEST_ARCS)
      .addParam("questsIds", SEARCH_PROP_TYPES.NUMBER, this.document.id)
      .json;

    const params = paramsHelper.loader()
      .setEndpointApi()
      .setAdditionalParam("filter", { id: 1, _type: 1, category: 1, locales: 1})
      .setSearchParams(searchParams);

    this.collectionService.search(params)
      .subscribe(
        r => {
          this.linkedArcs = r;
          if (this.linkedArcs.length == 0)
          {
            this.pageParams.setOnDeleteMessage("");
          }
          else
          {
            this.pageParams.setOnDeleteMessage("Не удалить! Привязан к сюжетным аркам.");
          }
        });
  }

  createArcLink(arc:ISearchItem):string[] {
    return createObjectLink(arc);
  }

  createArcLinkQuery(arc:ISearchItem):any {
    return createObjectLinkQuery(arc);
  }

  getArcName(arc:ISearchItem):string {
    return arc ? arc.locales ? localeUtils.findName(arc): 'NO NAME' : "MISSING";
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/quest-page/quest-page.component.ts